export class UserDtoModel {
  "email": string;
  "firstName": string;
  "lastName": string;
  "phone": string;
  "company": string;
  "additionalInfo": string;

  constructor(data: any) {
    this.email = data.email;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.phone = data.phone;
    this.company = data.company;
    this.additionalInfo = data.additionalInfo;
  }
}
